// Import createSlice from Redux Toolkit
import { createSlice } from '@reduxjs/toolkit';

// Define the initial state
const initialState = {
  selectedHierarchies: [],
  selectedStores: [],
  selectedProducts: [],
  selectedZones: [],
  selectedCampaigns: [],
  selectedPromotions: [],
  selectedSpecVariables: [],
  selectedSpecGroups: [],
  selectedFileItem: null,
  createdAwards: [],
  createdBuyListItems: []
};

// Create a Redux slice
const selectionSlice = createSlice({
  name: 'selected',
  initialState,
  reducers: {
    // Reducer function to update selectedHierarchies
    setSelectedHierarchies: (state, action) => {
      state.selectedHierarchies = action.payload;
    },
    // Reducer function to update selectedStores
    setSelectedStores: (state, action) => {
      state.selectedStores = action.payload;
    },
    // Reducer function to update selectedProducts
    setSelectedProducts: (state, action) => {
      state.selectedProducts = action.payload;
    },
    // Reducer function to update selectedZones
    setSelectedZones: (state, action) => {
      state.selectedZones = action.payload;
    },
    setSelectedCampaigns: (state, action) => {
      state.selectedCampaigns = action.payload;
    },
    setSelectedPromotions: (state, action) => {
      state.selectedPromotions = action.payload;
    },
    setSelectedSpecVariables: (state, action) => {
      state.selectedSpecVariables = action.payload;
    },
    setSelectedSpecGroups: (state, action) => {
      state.selectedSpecGroups = action.payload;
    },
    setSelectedFileItem: (state, action) => {
      state.selectedFileItem = action.payload;
    },
    setCreatedAwards: (state, action) => {
      state.createdAwards = [...state.createdAwards, ...action.payload];
    },
    setCreatedBuyListItems: (state, action) => {
      state.createdBuyListItems = [...state.createdBuyListItems, ...action.payload];
    },
    resetSlectedProducts: (state, action) => {
      state.selectedProducts = [];
    },
    resetSelectedZones: (state, action) => {
      state.selectedZones = [];
    },
    resetCreatedAwards: (state, action) => {
      state.createdAwards = [];
    },
    resetCreatedBuyListItems: (state, action) => {
      state.createdBuyListItems = [];
    }

    // Reducer function to update selectedProducts
  }
});

// Export actions and reducer
export const {
  setSelectedHierarchies,
  setSelectedStores,
  setSelectedProducts,
  setSelectedZones,
  resetSelectedZones,
  setSelectedCampaigns,
  setSelectedPromotions,
  setSelectedSpecVariables,
  setSelectedSpecGroups,
  setSelectedFileItem,
  setCreatedAwards,
  setCreatedBuyListItems,
  resetSlectedProducts,
  resetCreatedAwards,
  resetCreatedBuyListItems
} = selectionSlice.actions;

export const selectSelectedHierarchies = (state) => state.selected.selectedHierarchies;
export const selectSelectedStores = (state) => state.selected.selectedStores;
export const selectSelectedProducts = (state) => state.selected.selectedProducts;
export const selectSelectedZones = (state) => state.selected.selectedZones;
export const selectSelectedCampaigns = (state) => state.selected.selectedCampaigns;
export const selectSelectedPromotions = (state) => state.selected.selectedPromotions;
export const selectSelectedFileItem = (state) => state.selected.selectedFileItem;
export const selectCreatedAwards = (state) => state.selected.createdAwards;
export const selectCreatedBuyListItems = (state) => state.selected.createdBuyListItems;
export const selectSelectedSpecVariables = (state) => state.selected.selectedSpecVariables;
export const selectSelectedSpecGroups = (state) => state.selected.selectedSpecGroups;

export default selectionSlice.reducer;
